import React from "react";
import { CURRENCY } from "src/config";
import { fNumber } from "src/utils/formatNumber";

// currency obj ref site : https://www.eurochange.co.uk/travel/tips/world-currency-abbreviations-symbols-and-codes-travel-money

const obj = {
  USD: "$",
  EUR: "€",
  GBP: "£",
  CNY: "¥",
  EGP: "£",
  INR: "₹",
  JPY: "¥",
};

export const Currency = ({ children }) => {
  const symbol = obj[CURRENCY];

  return (
    <>
      {symbol} {fNumber(parseFloat(children))}
    </>
  );
};

